export default __webpack_public_path__ + "static/media/apple-store.eff63fee.png";